import { createFileRoute } from "@tanstack/react-router";
import FibromyalgiaPage from "@/pages/FibromyalgiaPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute(
  "/fibromyalgia-treatment-coral-springs-fl",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Fibromyalgia Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Fibromyalgia treatment in Coral Springs, FL. Ketamine therapy and supportive care for fibromyalgia at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "Fibromyalgia Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Fibromyalgia treatment in Coral Springs, FL. Ketamine therapy and supportive care for fibromyalgia at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/fibromyalgia-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/fibromyalgia-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Fibromyalgia Treatment Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Relieve widespread fibromyalgia pain, fatigue, and fibro-fog with IV Ketamine therapy at Neuro Wellness TMS Centers of America in Coral Springs, FL.",
              canonical: "/fibromyalgia-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Fibromyalgia",
                  href: "/fibromyalgia-treatment-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FibromyalgiaPage />;
}
